import type { ReactNode } from 'react';

export const symbol_co_present: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M860-131v-649H100v290q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Q40-477.25 40-490v-290q0-24.75 17.63-42.38Q75.25-840 100-840h760q24.75 0 42.38 17.62Q920-804.75 920-780v580q0 26-17 45.5T860-131ZM252-443q-42-42-42-108t42-108q42-42 108-42t108 42q42 42 42 108t-42 108q-42 42-108 42t-108-42Zm172.5-43.5Q450-512 450-551t-25.5-64.5Q399-641 360-641t-64.5 25.5Q270-590 270-551t25.5 64.5Q321-461 360-461t64.5-25.5ZM100-80q-24.75 0-42.37-17.63Q40-115.25 40-140v-34q0-38 19-65t49-41q67-30 128.5-45T360-340q62 0 123 15.5t127.92 44.69q31.3 14.13 50.19 40.97Q680-212 680-174v34q0 24.75-17.62 42.37Q644.75-80 620-80H100Zm0-60h520v-34q0-16-9.5-30.5T587-226q-64-31-117-42.5T360-280q-57 0-111 11.5T132-226q-14 7-23 21.5t-9 30.5v34Zm260-411Zm0 411Z"
		/>
	</svg>
);
